import AiCourseCreation from './AiCourseCreation'

export default AiCourseCreation
